import React, { useEffect, useState, useRef } from 'react'
import './BottomNav.css'
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faTowerBroadcast, faDollarSign, faCommentDots, faUserAlt, faAdd, faRocket } from '@fortawesome/free-solid-svg-icons'
import { getAuth } from 'firebase/auth'
import { getDatabase, ref, onValue } from 'firebase/database'

function BottomNavUser() {
  const auth = getAuth()
  const rtdb = getDatabase()
  const [unreadCount, setUnreadCount] = useState(0)
  const prevUnreadRef = useRef(0)
  const [pulse, setPulse] = useState(false)

  useEffect(() => {
    const user = auth.currentUser
    if (!user) return

    const chatsRef = ref(rtdb, 'chats')
    const lastReadRef = ref(rtdb, 'lastRead')

    let chatsData = {}
    let lastReadData = {}

    const calculateUnread = () => {
      let count = 0
      Object.keys(chatsData).forEach(chatId => {
        if (!chatId.includes(user.uid)) return
        const messages = Object.values(chatsData[chatId] || {})
        const lastRead = lastReadData?.[chatId]?.[user.uid] || 0
        messages.forEach(msg => {
          if (msg.receiverId === user.uid && msg.timestamp > lastRead) count += 1
        })
      })

      if (count > prevUnreadRef.current) {
        setPulse(true)
        setTimeout(() => setPulse(false), 600)
      }

      prevUnreadRef.current = count
      setUnreadCount(count)
    }

    const unsubChats = onValue(chatsRef, snap => {
      chatsData = snap.val() || {}
      calculateUnread()
    })

    const unsubLastRead = onValue(lastReadRef, snap => {
      lastReadData = snap.val() || {}
      calculateUnread()
    })

    return () => {
      unsubChats()
      unsubLastRead()
    }
  }, [auth, rtdb])

  return (
    <div className="bottomNav">
      <NavLink to="/user/dashboard" className="bottomNavLink">
        <FontAwesomeIcon icon={faBars} />
        <span>Home</span>
      </NavLink>
      <NavLink to="/user/influencers" className="bottomNavLink">
        <FontAwesomeIcon icon={faRocket} />
        <span>Influencers</span>
      </NavLink>
      <NavLink to="/user/run-ads" className="bottomNavLink">
        <FontAwesomeIcon icon={faAdd} />
        <span>Run Ads</span>
      </NavLink>
      <NavLink to="/user/ads" className="bottomNavLink">
        <FontAwesomeIcon icon={faTowerBroadcast} />
        <span>My Ads</span>
      </NavLink>
      <NavLink to="/user/messages" className="bottomNavLink" style={{ position: 'relative' }}>
        <FontAwesomeIcon icon={faCommentDots} />
        <span>Messages</span>
        {unreadCount > 0 && (
          <span className={`messageBadgeBottom ${pulse ? 'pulse' : ''}`}>
            {unreadCount}
          </span>
        )}
      </NavLink>
      <NavLink to="/user/profile" className="bottomNavLink">
        <FontAwesomeIcon icon={faUserAlt} />
        <span>Profile</span>
      </NavLink>
    </div>
  )
}

export default BottomNavUser